{
  "1e3564bdba890599": "Preferencias de Notificación",
  "4840a57222fc401c": "Desactivado",
  "4ba2056e9ba62960": "Notificación Web",
  "5c81e533cbb65983": "Las notificaciones por SMS están desactivadas porque no se ha establecido un número de móvil. Agrega un número de móvil en Información Personal para habilitar las notificaciones por SMS.",
  "731ce7ed808913b2": "Empujar",
  "92340695899bd2d8": "Activo",
  "969ccbd3cf6300ec": "Correo Electrónico",
  "c8df66c5fe3f97d0": "Cerrar diálogo",
  "e2204b3eaff613de": "Miembros del Equipo"
}
